var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-video-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-video-detail__withData",attrs:{"poster":_vm.currentPoster}},[_vm._v(">")])}
var staticRenderFns = []

export { render, staticRenderFns }